<template>
  <div class="flex act-container">
    <div>
      <act-preview
        phoneHeaderFixed
        navigationBg="transparent"
        phoneBodyOverflowHidden
        navigationTitle="领取收益"
        phoneHeaderFixedColor="#fff"
      >
        <div
          class="slot"
          :style="{ backgroundImage: 'url(' + ruleForm.spreadBgp2 + ')' }"
        >
        </div>
      </act-preview>
    </div>
    <div class="add-goods-container">
      <div class="act-step-wrapper">
        <hm-step
          :steps="steps"
          :scroll="true"
          :step="currentStep"
          @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollHeight + 'px' }">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="170px"
          >
            <div id="base">1.基本信息</div>
            <el-form-item label="活动标题" prop="spreadName">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                maxlength="25"
                v-model.trim="ruleForm.spreadName"
                placeholder="请输入活动标题"
                :disabled="disabled"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动时间段选择" prop="activityDate">
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                v-model="ruleForm.activityDate"
                type="datetimerange"
                align="right"
                :picker-options="pickerOptions"
                start-placeholder="活动开始时间"
                end-placeholder="活动结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                :disabled="disabled"
              ></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="背景音乐链接" prop="spreadBgm">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model="ruleForm.spreadBgm"
                placeholder="请输入音乐链接/音乐网络地址"
                :disabled="disabled"
              ></el-input>
            </el-form-item> -->
            <div id="gameRule">{{ steps.length === 3 ? 2 : 2 }}活动规则</div>
            <el-form-item label="总投放金额限制：" required>
              <div class="flex">
                <span>红包总发放达到 </span>
                <el-form-item prop="totalMonery">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.totalMonery"
                    @input="filterGt0OrFixed2('totalMonery')"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span>元时停止发放红包，向用户展示文案 </span>
                <el-form-item prop="stopSHowMsg">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.stopSHowMsg"
                    placeholder="请输入展示文案"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="用户红包金额限制：" required>
              <div class="flex">
                <span> 向用户发放 </span>
                <el-form-item prop="singleOnceLowerLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('singleOnceLowerLimit')"
                    v-model.trim="ruleForm.singleOnceLowerLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span> 元～ </span>
                <el-form-item prop="singleOnceUpperLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('singleOnceUpperLimit')"
                    v-model.trim="ruleForm.singleOnceUpperLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>

                <span> 元的小额红包</span>
              </div>
            </el-form-item>
            <div id="gameAstrict">{{ steps.length === 3 ? 3 : 3 }}活动限制</div>
            <el-form-item :label="labelName" prop="memberFromType">
              <el-radio-group
                v-model="ruleForm.memberFromType"
                :disabled="disabled"
              >
                <el-radio label="0">全部人员</el-radio>
                <el-radio label="1">指定用户</el-radio>
                <el-radio label="2">导入用户</el-radio>
              </el-radio-group>
              <div v-if="ruleForm.memberFromType === '1' && !disabled">
                <el-input
                  type="textarea"
                  style="width: 400px"
                  :rows="6"
                  placeholder="手动输入，一行一个号码，回车切换下一行，"
                  v-model="ruleForm.inputMobiles"
                  :disabled="disabled"
                >
                </el-input>
                <el-button
                  type="primary"
                  size="small"
                  @click="searchByPhone"
                  :disabled="disabled"
                  >查询</el-button
                >
                <div class="form-item-tip">
                  手动输入，一行一个号码，回车切换下一行，
                </div>
                <div class="form-item-tip">
                  每次最多能提交2000个号码。建议50个号码以上的用文件导入
                </div>
              </div>
              <div
                v-else-if="ruleForm.memberFromType === '2'"
                style="width: 500px"
              >
                <div class="flex flex-end mb10" v-if="!disabled">
                  <el-button size="small" @click="outputExcel" type="primary"
                    >导出模板</el-button
                  >
                  <el-button type="primary" class="open-file" size="small">
                    导入数据
                    <input
                      type="file"
                      @change="importf"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                  </el-button>
                </div>
              </div>
              <div style="width: 500px" v-if="ruleForm.memberFromType !== '0'">
                <el-table
                  stripe
                  border
                  ref="table"
                  :data="ruleForm.spreadActivityMemberInfos"
                  style="width: 100%"
                  max-height="400"
                  size="small"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    header-align="center"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="fromName"
                    label="用户名"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="fromMobile"
                    label="手机号"
                  >
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div class="flex flex-center" v-if="!disabled">
                        <el-tooltip class="item" content="删除" placement="top">
                          <div
                            class="pointer mr10"
                            @click="removeGoods(scope.$index)"
                          >
                            <span class="hmicon icon-shanchu primary"></span>
                          </div>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                v-if="!disabled"
                @click="submitForm('ruleForm')"
                >发布</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </el-scrollbar>
      </div>
      
    </div>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误
        </div>
        <el-table
          max-height="400"
          size="small"
          stripe
          :data="errInputResult"
          border
          class="small-table"
        >
          <el-table-column
            prop="fromMobile"
            header-align="center"
            align="center"
            label="手机号查不到相关用户"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="specBarcode"
            label="无效条码"
          ></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
// import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import actPreview from "@/components/actPreview";
import HmForm from "@/components/HmForm";
import XLSX from "xlsx";
import { arrayUnique2 } from "@/utils/utils";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: {
    HmStep,
    HmRichEditor,
    actPreview,
    HmForm
  },
  data() {
    const patternFormMember = (rule, val, callback) => {
      if (val != "0") {
        if (!this.ruleForm.spreadActivityMemberInfos.length) {
          return callback(new Error("请导入用户"));
        }
      }
      callback();
    };
    const patternValueUpperLimit = (rule, val, callback) => {
      // if (new Number(val) < 0.01 || new Number(val) > 0.3  ) {
      //   return callback(new Error("最小不能低于0.01,最大不超过0.3"));
      // }
      if(this.ruleForm.singleOnceUpperLimit==0){
        return callback(new Error("金额限制不能为0"));
      }
      if(this.ruleForm.singleOnceLowerLimit && this.ruleForm.singleOnceUpperLimit && this.ruleForm.singleOnceLowerLimit > this.ruleForm.singleOnceUpperLimit){
        return callback(new Error("金额限制最小值不能大于最大值"));
      }
      callback();
    };
    const patternValueLowerLimit = (rule, val, callback) => {
      // if (new Number(val) < 0.01 || new Number(val) > 0.3  ) {
      //   return callback(new Error("最小不能低于0.01,最大不超过0.3"));
      // }
      if(this.ruleForm.singleOnceLowerLimit==0){
        return callback(new Error("金额限制不能为0"));
      }
      if(this.ruleForm.singleOnceLowerLimit && this.ruleForm.singleOnceUpperLimit && this.ruleForm.singleOnceLowerLimit > this.ruleForm.singleOnceUpperLimit){
        return callback(new Error("金额限制最小值不能大于最大值"));
      }
      callback();
    };
    return {
      errInputResult: [],
      errValidGoods: false,
      disabled: false,
      earningsList: [
        {
          goodsName: "贝婴美",
          price: "+10.00"
        },
        {
          goodsName: "BOBO奶瓶",
          price: "+10.00"
        }
      ],
      videoUploadPercent: 0,
      videoFlag: false,
      uploadShow: true,
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      scrollHeight: 0,
      currentStep: 1,
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        },
        {
          id: "gameAstrict",
          name: "活动限制"
        }
      ],
      rules: {
        spreadName: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: "blur"
          },
          {
            required: true,
            min: 2,
            max: 16,
            message: "名称应大于2小于16个字",
            trigger: "blur"
          }
        ],
        activityDate: {
          required: true,
          message: "请选择活动时段",
          trigger: "blur"
        },
        totalMonery: {
          required: true,
          message: "请输入金额"
        },
        stopSHowMsg: {
          required: true,
          message: "请输入展示文案"
        },
        singleOnceLowerLimit: [{
          required: true,
          message: "请输入金额"
        },
        { required: true, validator: patternValueLowerLimit }
        ],
        singleOnceUpperLimit: [{
          required: true,
          message: "请输入金额"
        },
        { required: true, validator: patternValueUpperLimit }
        ],
        contactsTel: [
          {
            required: true,
            message: "请输入邮箱"
          }
        ],
       
        memberFromType: [
          {
            required: true,
            message: "请选择参与人员"
          },
          {
            required: true,
            validator: patternFormMember
          }
        ]
      },
      ruleForm: {
        spreadTarget: "",
        spreadName: "",
        activityDate: "",
        spreadStartTime: "",
        spreadEndTime: "",
        spreadBgm: "",
        spreadBgp3: "https://imgcdn.hemiao100.com/ThemePictures/jianglibgp.png",        
        spreadBgp2:
          "https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/banner_04.png",
        totalMonery: "",
        stopSHowMsg: "红包悄悄溜走了",
        everydaySpreadType: "1",
        singleOnceUpperLimit: "", //everydaySpreadInfo{}
        singleOnceLowerLimit: "", //everydaySpreadInfo{}
        // contactsTel: "", //spreadWarnRemind{}
        memberFromType: "0",
        spreadActivityMemberInfos: [],
        inputMobiles: ""
      },
      type: "",
      labelName: "",
      memberPhoneList: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcHeight();
    this.type = this.$route.query.type;

    this.ruleForm.spreadTarget = this.$route.query.spreadTarget;
    if (this.type !== "add") {
      this.id = this.$route.query.id;
      this.queryDetails();
    }
    if (this.type === "details") {
      this.disabled = true;
    }
    if (this.$route.query.spreadTarget === "guider") {
      this.labelName = "可参与活动的导购：";
    } else if (this.$route.query.spreadTarget === "supplier") {
      this.labelName = "可参与活动的业务员：";
    } else if (this.$route.query.spreadTarget === "store") {
      this.labelName = "可参与活动的采购：";
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    async querySpreadMember() {
      let params = {
        spreadTarget: 'guider',
        memberPhoneList: this.memberPhoneList
      };
      const { code, result } = await this.$store.dispatch(
        "querySpreadMember",
        params
      );

      if (code === "0") {
        const { succeeList, errorList } = result;
        if (succeeList.length) {
          this.ruleForm.spreadActivityMemberInfos.push.apply(
            this.ruleForm.spreadActivityMemberInfos,
            succeeList
          );
          this.ruleForm.spreadActivityMemberInfos = arrayUnique2(
            this.ruleForm.spreadActivityMemberInfos,
            "fromId"
          );
        }

        if (errorList.length) {
          this.errValidGoods = true;
          this.errInputResult = errorList;
        }
        this.$refs.ruleForm.validateField("memberFromType");
      }
    },
    async queryDetails() {
      const { code, result } = await this.$store.dispatch(
        "detailsRedpackageSpreadActivity",
        {
          id: this.id
        }
      );
      if (code === "0") {
        const {
          spreadActivityBasicInfo,
          redpackageVideoAdRewardMoneyRuleV1,
          columnsInfoModels,
          memberFromType,
          spreadActivityMemberInfos
        } = result;
        // this.$refs.hmform.list = columnsInfoModels;
        for (let key in spreadActivityBasicInfo) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = spreadActivityBasicInfo[key];
          }
        }
        this.ruleForm.memberFromType = memberFromType;
        if (memberFromType != "0") {
          this.ruleForm.spreadActivityMemberInfos = spreadActivityMemberInfos;
        }
        this.ruleForm.activityDate = [
          spreadActivityBasicInfo.spreadStartTime,
          spreadActivityBasicInfo.spreadEndTime
        ];
        for (let key in redpackageVideoAdRewardMoneyRuleV1) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = redpackageVideoAdRewardMoneyRuleV1[key];
          }
        }
        this.ruleForm.spreadBgp2 = "https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/banner_04.png";
        this.ruleForm.spreadBgp3 = "https://imgcdn.hemiao100.com/ThemePictures/jianglibgp.png";
      }
    },
    searchByPhone() {
      let memberMobiles = [];
      this.ruleForm.inputMobiles.split(/[(\r\n)\r\n]+/).forEach(v => {
        if (v !== "") {
          memberMobiles.push(v.replace(/\s*/g, ""));
        }
      });
      this.memberPhoneList = memberMobiles;
      this.querySpreadMember();
    },
    removeGoods(index) {
      this.ruleForm.spreadActivityMemberInfos.splice(index, 1);
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["手机号"];
        const data = [];

        exportJsonToExcel(tHeader, data, "导入手机号模板");
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        that.memberPhoneList = [];
        let isValid = true;
        let isRequired = true;
        result.forEach(v => {
          // if (!v[0] || !v[1] || !v[2] || !v[3] || !v[4] || !v[5]) {
          //   isRequired = false;
          // } else {
          //   if (!that.isString(v[3]) || !that.isString(v[4])) {
          //     isValid = false;
          //   }
          // }
          that.memberPhoneList.push(v[0]);
        });
        if (isValid && isRequired) {
          that.querySpreadMember();
          // that.memberCount = formatResult.length;
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整商品信息！",
              type: "warning"
            });
          } else if (!isValid) {
            that.$message({
              message: "导入失败，日期请使用文本格式导入！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    uploadVideoProcess(event, file) {
      this.videoFlag = true;
      this.videoUploadPercent =
        file.percentage < 100 ? Math.round(file.percentage) : 99;
    },
    beforeUploadVideo(file) {
      const isLt10M = file.size / 1024 / 1024 < 100;
      if (
        [
          "video/mp4"
          // "video/ogg",
          // "video/flv",
          // "video/avi",
          // "video/wmv",
          // "video/rmvb"
        ].indexOf(file.type) === -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传视频大小不能超过100MB哦!");
        return false;
      }
    },
    
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.uploadShow = false;
    },
    // 移除上传文件
    handleRemove(spreadBgp) {
      this.ruleForm[spreadBgp] = "";
    },
  
    // 正在上传
    uploading() {
      this.uploadShow = true;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
    handleResize() {
      this.calcHeight();
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else if (e.target.scrollTop < 100) {
            this.currentStep = 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed2(prop) {
      // if(prop!=="totalMonery"){
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      // }
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    //0.00转0
    verify() {
      this.ruleForm.totalMonery = new Number(this.ruleForm.totalMonery);
      this.ruleForm.singleOnceLowerLimit = new Number(
        this.ruleForm.singleOnceLowerLimit
      );
      this.ruleForm.singleOnceUpperLimit = new Number(
        this.ruleForm.singleOnceUpperLimit
      );
    },
    async submitForm(formName) {
      this.verify();
      try {
        const valid = await this.$refs[formName].validate();
        if (valid) {
          if(this.ruleForm.singleOnceUpperLimit == 0 || this.ruleForm.singleOnceLowerLimit == 0){
            this.$message({
              message: "用户红包金额限制不能为0！",
              type: "warning"
            });
            return false;
          }
          let ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
          let params = {
            spreadActivityBasicInfo: {
              spreadTarget: ruleForm.spreadTarget,
              spreadName: ruleForm.spreadName,
              spreadStartTime: ruleForm.activityDate[0],
              spreadEndTime: ruleForm.activityDate[1],
              spreadBgm: ruleForm.spreadBgm,
            },
            redpackageVideoAdRewardMoneyRuleV1: {
              totalMonery: ruleForm.totalMonery,
              singleOnceUpperLimit: ruleForm.singleOnceUpperLimit,
              singleOnceLowerLimit: ruleForm.singleOnceLowerLimit,  
            },
            memberFromType: ruleForm.memberFromType,
            spreadActivityMemberInfos: ruleForm.spreadActivityMemberInfos,
            // columnsInfoModels: this.$refs.hmform.list
          };
          let name =
            this.type === "edit"
              ? "editRedpackageSpreadActivity"
              : "createRedpackageSpreadActivity";
          if (this.type === "edit") {
            params.spreadActivityBasicInfo.id = this.id;
          }
          const { code } = await this.$store.dispatch(name, params);
          if (code === "0") {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.$router.back(-1);
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log("error: ", error);
        return;
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    cropSuccess() {}
  }
};
</script>
<style lang='scss' scoped>
.add-goods-container {
  flex-shrink: 0;
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 130px;
    height: 130px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priview-bgv {
  position: relative;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
    z-index: 999;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priview {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .phone-body {
    overflow: hidden !important;
  }
  .slot {
    position: relative;
    background-size: 100% 100%;
    height: 100%;
    &:hover {
      .change-bg {
        display: block;
      }
    }
    .upload-img {
      top: 60px;
    }
    .header-img-wrapper {
      box-sizing: border-box;
      .header-img {
        width: 100%;
        display: block;
      }
    }
    .change-bg {
      position: absolute;
      top: 60px;
      right: 0;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      z-index: 10;
      padding: 0 10px;
      display: none;
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }
    .title-img-wrapper {
      margin-left: 10px;
      margin-right: 10px;
      .rolling {
        padding: 0 30px;
        position: absolute;
        top: 46px;
        left: 0;
        right: 0;
        .notice-box {
          height: 30px;
          line-height: 30px;
          padding: 0 10px;
          .notice {
            width: 32px;
            background: #fcb70e;
            border-radius: 34px 0px 0px 34px;
            color: #fff;
          }
          .notice-people {
            font-size: 15px;
            text-align: center;
            color: #f52f1d;
            background: #feecdd;
            border-radius: 0px 34px 34px 0px;
          }
        }

        // div {
        //   border-radius: 50px;
        // }
      }
    }
    .title-content-wrapper {
      // position: absolute;
      // top: 500px;
      // left: 0;
      // right: 0;
      background: #fff;
      margin: 10px;
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 6px;
      .title-content {
        font-weight: bold;
        font-size: 19px;
      }
      .price {
        font-size: 20px;
      }
      .bold {
        font-weight: bold;
      }
    }
  }
}
</style>
